// en, de, fr, pt
export default {
	en: {
		Dashboard: 'Dashboard',
		RolesUsers: 'Users & Roles',
		Appconfigs: 'App configs',
		Roles: 'Roles',
		Users: 'Users',
		Settings: 'Settings',
		Categories: 'Categories',
		Contacts: 'Contacts',
		RecommendedApps: 'Recommended Apps',
		Translations: 'Translations',
		Terms: 'Terms & Conditions',
		Places: 'Places',
		AddPlaces: 'Add Place',
		AllPlaces: 'All Places',
		Languages: 'Languages',
		Filters: 'Filters',
		Groups: 'Groups',
	},
	fr: {
		
	},
	pt: {
		
	}
}
